import { environment } from '@/environments/environment';
import { LanguageEnum } from '@/app/shared/enums/language.enum';
import { SettingsConst } from '@/app/shared/consts/settings.const';

import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { LocalStorageService } from '@/app/shared/services/local-storage.service';

export const ApiInterceptor: HttpInterceptorFn = (request, next) => {
  const localStorageService = inject(LocalStorageService);

  let headers = request.headers;

  let modifiedUrl = '';
  if (!request.headers.has('X-Skip-Interceptor') && !request.url.includes('i18n')) {
    modifiedUrl = `${environment.apiUrl}${request.url}`;
  }
  if (request.headers.has('X-Skip-Interceptor')) {
    headers = headers.delete('X-Skip-Interceptor');
  }

  let modifiedRequest = request.clone({
    url: modifiedUrl,
    headers,
  });

  const currentLanguage = localStorageService.getItem(SettingsConst['languageStorageKey']) ?? LanguageEnum.En;
  modifiedRequest = modifiedRequest.clone({
    setHeaders: {
      'Accept-Language': currentLanguage,
    },
  });

  return next(modifiedRequest);
};
